var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[(_vm.act === 1)?_c('div',{staticClass:"loginAccount",on:{"click":_vm.setSonUser}},[_vm._v(" "+_vm._s(_vm.sonUser === 0 ? "主账号登录" : "子账号登录")+" ")]):_c('div',[_vm._v("已有账号，"),_c('span',{staticClass:"toLogin",on:{"click":function($event){return _vm.$emit('cahngeAct', 1)}}},[_vm._v("马上登录")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }